import {
  CHILD_NODE_SCHEMA_URL,
  DELETE_ROOT_NODE_SCHEMA_URL,
  GET_CHILD_NODES_SCHEMA_URL,
  PROPERTIES_SCHEMA_URL,
  RESOURCES_SCHEMA_URL,
  RESOURCE_SCHEMA_PROPERTY_URL,
  ROOT_NODES_SCHEMA_URL
} from '../constants/ApiUri';
import {
  PropertySchema,
  ResourceSchema,
  RootNodeSchema
} from '../types/SchemaExplorer';

import { Http } from 'vrlcm-gui-utils';

export const getRootNodes = async (): Promise<RootNodeSchema[]> => {
  const response = await Http.get<RootNodeSchema[]>(ROOT_NODES_SCHEMA_URL);
  return response.data;
};

export const addRootNode = async (
  schema: RootNodeSchema
): Promise<RootNodeSchema> => {
  const response = await Http.post<RootNodeSchema>(
    ROOT_NODES_SCHEMA_URL,
    schema
  );
  return response.data;
};

export const editRootNode = async (
  schema: RootNodeSchema
): Promise<RootNodeSchema> => {
  const response = await Http.put<RootNodeSchema>(
    ROOT_NODES_SCHEMA_URL,
    schema
  );
  return response.data;
};

export const deleteRootNode = async (vmid: string): Promise<void> => {
  const response = await Http.delete(DELETE_ROOT_NODE_SCHEMA_URL(vmid));
  return response.data;
};

export const getChildNodes = async (
  vmid: string
): Promise<ResourceSchema[]> => {
  const response = await Http.get<ResourceSchema[]>(
    GET_CHILD_NODES_SCHEMA_URL(vmid)
  );
  return response.data;
};

export const getResource = async (vmid: string): Promise<ResourceSchema> => {
  const response = await Http.get<ResourceSchema>(CHILD_NODE_SCHEMA_URL(vmid));
  return response.data;
};

export const addResource = async (
  resource: ResourceSchema
): Promise<ResourceSchema> => {
  const response = await Http.post<ResourceSchema>(
    RESOURCES_SCHEMA_URL,
    resource
  );
  return response.data;
};

export const editResource = async (
  resource: ResourceSchema
): Promise<ResourceSchema> => {
  const response = await Http.put<ResourceSchema>(
    RESOURCES_SCHEMA_URL,
    resource
  );
  return response.data;
};

export const deleteResource = async (vmid: string): Promise<void> => {
  const response = await Http.delete(CHILD_NODE_SCHEMA_URL(vmid));
  return response.data;
};

export const getResourceProperties = async (
  vmid: string
): Promise<PropertySchema[]> => {
  const response = await Http.get<PropertySchema[]>(
    RESOURCE_SCHEMA_PROPERTY_URL(vmid)
  );
  return response.data;
};

export const addProperty = async (
  property: PropertySchema
): Promise<PropertySchema> => {
  const response = await Http.post<PropertySchema>(
    PROPERTIES_SCHEMA_URL,
    property
  );
  return response.data;
};

export const editProperty = async (
  property: PropertySchema
): Promise<PropertySchema> => {
  const response = await Http.put<PropertySchema>(
    PROPERTIES_SCHEMA_URL,
    property
  );
  return response.data;
};
